module.exports = "/_next/static/images/7359ab8b4f5da2ecd209f86346cc2b7d-man-holding-device-2@1.5x.jpg.webp";